import React, { useState, useEffect } from "react";
import {
  Box,
  Heading,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  TableContainer,
  Spinner,
  Center,
  useToast,
  Flex,
  Button,
} from "@chakra-ui/react";
import Navbar from "../Navbar/Navbar";
import Sidebar from "../Sidebar";
import axios from "axios";
import * as mod from "../../url";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const SIDEBAR_WIDTH = "250px";

const EmailSubscriber = () => {
  const [emails, setEmails] = useState([]);
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  const storedData = JSON.parse(sessionStorage.getItem("superAdminLawvs"));
  const token = storedData?.data?.token;

  const config = {
    headers: { Authorization: token ? `${token}` : "" },
  };

  const getAllSubscribers = async () => {
    if (!token) {
      toast({
        title: "Unauthorized Access",
        description: "Please login again as Super Admin.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      setLoading(true);
      const { data } = await axios.get(
        `${mod.api_url}/api/v1/newslatter/all/subscribers`,
        config
      );
      if (data?.data) {
        setEmails(data.data);
      } else {
        setEmails([]);
      }
    } catch (error) {
      toast({
        title: "Failed to load subscribers",
        description: error.response?.data?.message || "Please try again later.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllSubscribers();
  }, []);

  const exportToExcel = () => {
    if (!emails || emails.length === 0) {
      toast({
        title: "No Data to Export",
        description: "There are no subscribers to export.",
        status: "info",
        duration: 3000,
        isClosable: true,
      });
      return;
    }
    const formattedData = emails.map((item, index) => ({
      "S.No": index + 1,
      Email: item.email,
      Status: item.status,
      "Created At": new Date(item.createdAt).toLocaleString("en-IN", {
        dateStyle: "medium",
        timeStyle: "short",
      }),
    }));
    const worksheet = XLSX.utils.json_to_sheet(formattedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Subscribers");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(
      blob,
      `Email_Subscribers_${new Date().toISOString().slice(0, 10)}.xlsx`
    );
  };
  return (
    <>
      <Navbar />
      <Sidebar />
      <Box
        mt="70px"
        ml={{ base: 0, md: SIDEBAR_WIDTH }}
        p={5}
        bg="#f8f9fa"
        minH="100vh"
      >
        <Box
          textAlign="center"
          mb={6}
          bg="teal.500"
          py={3}
          borderRadius="md"
          color="white"
          boxShadow="md"
        >
          <Heading fontSize="xl">Email Subscribers</Heading>
          <Text fontSize="sm" opacity={0.9}>
            Manage all newsletter subscribers here
          </Text>
        </Box>
        <Flex justify="space-between" align="center" mb={3}>
          <Text fontWeight="medium">
            Total Subscribers:{" "}
            <Text as="span" color="teal.600" fontWeight="bold">
              {emails?.length || 0}
            </Text>
          </Text>
          <Box>
            <Button colorScheme="teal" size="sm" onClick={exportToExcel}>
              Export to Excel
            </Button>
          </Box>
        </Flex>
        <Box
          bg="white"
          borderRadius="lg"
          shadow="md"
          p={3}
          overflowX="auto"
          border="1px solid #94989eff"
        >
          {loading ? (
            <Center py={10}>
              <Spinner size="lg" color="teal.500" />
            </Center>
          ) : emails?.length === 0 ? (
            <Center py={10}>
              <Text color="gray.500">No subscribers found.</Text>
            </Center>
          ) : (
            <TableContainer>
              <Table variant="simple">
                <Thead bg="teal.600">
                  <Tr>
                    <Th color="white">#</Th>
                    <Th color="white">Email</Th>
                    <Th color="white">Status</Th>
                    <Th color="white">Created At</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {emails?.map((data, index) => (
                    <Tr
                      key={data._id}
                      _hover={{ bg: "gray.50" }}
                      transition="0.2s"
                    >
                      <Td>{index + 1}</Td>
                      <Td fontWeight="medium">{data.email}</Td>
                      <Td fontWeight="medium">{data.status}</Td>
                      <Td>
                        {new Date(data.createdAt).toLocaleString("en-IN", {
                          dateStyle: "medium",
                          timeStyle: "short",
                        })}
                      </Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          )}
        </Box>
      </Box>
    </>
  );
};

export default EmailSubscriber;
